import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetEditoriallistStyle0 = gravityIconIndividualCss;

const GravityIconAssetEditoriallist = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '60534ff2227e0fd8e699cf36b2ff0ee4c6c10b93', color: this.color, size: this.size }, h("svg", { key: 'e102bc183e08c1125a22567bfd69794f44ff5dd3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '8a9a74bc5d1420457ac5c5442bff47dfa729fa14', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.54 4.002 19.36 4c.223 0 .304.023.385.067a.454.454 0 0 1 .19.189c.043.081.066.162.066.385v12.718c0 .223-.023.304-.067.385a.454.454 0 0 1-.189.19c-.081.043-.162.066-.385.066H2.641c-.223 0-.304-.023-.385-.067a.454.454 0 0 1-.19-.189.59.59 0 0 1-.064-.285L2 4.641c0-.223.023-.304.067-.385a.454.454 0 0 1 .189-.19.59.59 0 0 1 .285-.064ZM18.5 5.5h-15v11h15v-11ZM17 7h-4v8h4V7Z", fill: "currentColor" }))));
    }
};
GravityIconAssetEditoriallist.style = GravityIconAssetEditoriallistStyle0;

export { GravityIconAssetEditoriallist as gravity_icon_asset_editoriallist };

//# sourceMappingURL=gravity-icon-asset-editoriallist.entry.js.map